import { differenceInCalendarDays, format, isValid, parseISO, startOfDay } from "date-fns";
import { getDateFnsLocale } from "@/features/credentials/pages/list/lib/get-date-fns-locale";

export function parseExpiryDate(value?: string | null): Date | undefined {
  if (value == null || value.trim() === "") {
    return undefined;
  }

  const trimmed = value.trim();

  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    const parsed = parseISO(trimmed);
    return isValid(parsed) ? parsed : undefined;
  }

  const isoCandidate = parseISO(trimmed);
  if (isValid(isoCandidate)) {
    return isoCandidate;
  }

  const isoPrefix = parseISO(trimmed.slice(0, 10));
  if (isValid(isoPrefix) && /^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
    return isoPrefix;
  }

  const parsed = new Date(trimmed);
  return isValid(parsed) ? parsed : undefined;
}

export function getExpiryDays(value?: string | null): number | undefined {
  const parsed = parseExpiryDate(value);
  if (!parsed) {
    return undefined;
  }

  return differenceInCalendarDays(startOfDay(parsed), startOfDay(new Date()));
}

export function isCredentialExpired(value?: string | null): boolean {
  const days = getExpiryDays(value);
  return days != null && days < 0;
}

export function formatExpiryDate(value?: string | null, language = "en"): string | undefined {
  const parsed = parseExpiryDate(value);
  if (!parsed) {
    return undefined;
  }

  return format(parsed, "PPP", { locale: getDateFnsLocale(language) });
}
